import { newId } from "../utils/dataTypesUtils"
import { UnitType, UnitTypeCategory, UnitTypeName } from "../../../modules/stock"

export const DefaultUnitTypeId = '1'

export const unitTypes = (): UnitType[] => [
    { id: DefaultUnitTypeId, name: UnitTypeName.UNIT, abbreviation: 'u', category: UnitTypeCategory.BASIC },
    { id: newId(), name: UnitTypeName.MILLIMETER, abbreviation: 'mm', category: UnitTypeCategory.LENGTH },
    { id: newId(), name: UnitTypeName.CENTIMETER, abbreviation: 'cm', category: UnitTypeCategory.LENGTH },
    { id: newId(), name: UnitTypeName.METER, abbreviation: 'm', category: UnitTypeCategory.LENGTH },
    { id: newId(), name: UnitTypeName.MILLIGRAM, abbreviation: 'mg', category: UnitTypeCategory.WEIGHT },
    { id: newId(), name: UnitTypeName.GRAM, abbreviation: 'g', category: UnitTypeCategory.WEIGHT },
    { id: newId(), name: UnitTypeName.KILOGRAM, abbreviation: 'kg', category: UnitTypeCategory.WEIGHT },
    { id: newId(), name: UnitTypeName.TON, abbreviation: 'tn', category: UnitTypeCategory.WEIGHT },
    { id: newId(), name: UnitTypeName.SQUARE_CENTIMETER, abbreviation: 'cm2', category: UnitTypeCategory.AREA },
    { id: newId(), name: UnitTypeName.SQUARE_METER, abbreviation: 'm2', category: UnitTypeCategory.AREA },
    { id: newId(), name: UnitTypeName.MILLILITER, abbreviation: 'mlt', category: UnitTypeCategory.VOLUME },
    { id: newId(), name: UnitTypeName.LITER, abbreviation: 'lt', category: UnitTypeCategory.VOLUME },
    { id: newId(), name: UnitTypeName.CUBIC_METER, abbreviation: 'm3', category: UnitTypeCategory.VOLUME }
]
